import { Access } from "../../access/models/Access";
import { SharingStatus } from "../../access/models/SharingStatus";
import { Page } from "../../shared/utils/http-utils";
import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import { Campaign } from "../models/Campaign";
import { DashboardTypes } from "../models/Dashboard";
import { ForecastScenario } from "../models/ForecastScenario";
import {
  CreateProject,
  Project,
  UpdateSharingStatus,
  UpdateProject,
} from "../models/Project";

export const ProjectApi = {
  pageCampaigns: async (
    projectId: string,
    pageSize: number,
    pageNumber: number
  ) =>
    await optionalAuthAxios().get<Page<Campaign>>(
      `/projects/${projectId}/campaigns`,
      {
        params: {
          "page[size]": pageSize,
          "page[number]": pageNumber,
        },
      }
    ),

  validatePassword: async (projectId: string) =>
    await optionalAuthAxios().get(`/projects/${projectId}/validate-password`),

  get: async (projectId: string) =>
    await optionalAuthAxios().get<Project>(`/projects/${projectId}`),

  page: async (pageSize: number, pageNumber: number) =>
    await jwtAuthAxios().get<Page<Project>>(`/projects`, {
      params: { "page[size]": pageSize, "page[number]": pageNumber },
    }),

  create: async (project: CreateProject) =>
    await jwtAuthAxios().post<Project>(`/projects`, project),

  update: async (body: UpdateProject, id: string) =>
    await jwtAuthAxios().put<Project>(`/projects/${id}`, body),

  delete: async (projectId: string) =>
    await jwtAuthAxios().delete(`/projects/${projectId}`),

  deleteMyAccess: async (projectId: string) =>
    await jwtAuthAxios().delete(`/projects/${projectId}/my-access`),

  getSharingStatus: async (projectId: string) =>
    await jwtAuthAxios().get<SharingStatus>(
      `/projects/${projectId}/sharing-status`
    ),

  updateSharingStatus: async (
    projectId: string,
    body: UpdateSharingStatus
  ) =>
    await jwtAuthAxios().put<SharingStatus>(
      `/projects/${projectId}/sharing-status`,
      body
    ),

  listAccesses: async (projectId: string) =>
    await jwtAuthAxios().get<Access[]>(`/projects/${projectId}/accesses`),

  postAccountAccess: async (projectId: string) =>
    await jwtAuthAxios().post<Project>(`/projects/${projectId}/account-access`),

  listDashboards: async (projectId: string) =>
    await optionalAuthAxios().get<DashboardTypes.Dashboard[]>(
      `/projects/${projectId}/dashboards`
    ),

  listForecastScenarios: async (projectId: string) =>
    await optionalAuthAxios().get<ForecastScenario[]>(
      `/projects/${projectId}/forecast-scenarios`
    ),
};
